/** The agent column's width: Figma «Chat 380 (default)» and «Chat 560 (max)», dragged on its right edge. */
type WidthStorage = Pick<Storage, 'getItem' | 'setItem'>;

const WIDTH_KEY = 'hp.agent.width';
export const AGENT_WIDTH = { min: 320, max: 560, initial: 380 } as const;

export const clampAgentWidth = (width: number): number =>
  Number.isFinite(width) ? Math.min(AGENT_WIDTH.max, Math.max(AGENT_WIDTH.min, Math.round(width))) : AGENT_WIDTH.initial;

/** The width a drag that took the edge at `from` with the column `width` wide gives at the pointer's `x`. */
export const dragAgentWidth = (width: number, from: number, x: number): number => clampAgentWidth(width + x - from);

const local = (): WidthStorage | undefined => typeof localStorage === 'undefined' ? undefined : localStorage;

export function storedAgentWidth(storage = local()): number {
  try {
    const raw = storage?.getItem(WIDTH_KEY);
    return raw ? clampAgentWidth(Number(raw)) : AGENT_WIDTH.initial;
  } catch { return AGENT_WIDTH.initial; }
}

export function storeAgentWidth(width: number, storage = local()): void {
  try { storage?.setItem(WIDTH_KEY, String(clampAgentWidth(width))); } catch { /* private mode or quota: the width lasts this page */ }
}

/** The stage a 1024 window keeps beside the default column, where the 3D bottom row still fits (measured 2026-11-04). */
const MIN_STAGE = 644;
/** The width shown in a window: the kept one, narrowed so the stage keeps `MIN_STAGE`, never under the minimum. */
export const fitAgentWidth = (width: number, windowWidth: number): number => clampAgentWidth(Math.min(width, windowWidth - MIN_STAGE));
